import * as validation from '@/class/common/validation';

export const CHECK_TYPE = validation.CHECK_TYPE;

export interface IPValidation extends validation.IValidation  {
  type: 'text' | 'number' | 'time' | 'date' | 'radio' | 'select' | 'textarea' | 'password' | 'check' | 'search' ;
  name: string;
  placeholder?: string;
  error?: string;
}

const INPUT_TYPE = {
  TEXT: 'text',
  NUMBER: 'number',
  TIME: 'time',
  DATE: 'date',
  RADIO: 'radio',
  SELECT: 'select',
  TEXTAREA: 'textarea',
  PASSWORD: 'password',
};

export function checkValue(value: any, item: IPValidation): boolean {
  item.error = '';
  let valuelength = 0;
  const paramType = typeof value;
  switch (paramType) {
    case validation.VALIDATION.TYPE.NUMBER:
      valuelength = 1;
      break;
    case validation.VALIDATION.TYPE.BOOLEAN:
      valuelength = value;
      break;
    case validation.VALIDATION.TYPE.STRING:
      valuelength = [...value].length;
      break;
    default:
      item.error  += '項目が異常です。 ';
      return false;
  }
  // 空白チェック
  if (isEmpty(String(value), item)) {
    return true;
  }

  // required
  if (item.required && valuelength <= 0) {
    item.error  += '必須項目です。 ';
  }
  // max and min
  if (valuelength > 0) {
    // max
    if (item.max) {
      if (item.max < valuelength) {
        item.error  += `${item.max}文字以下で入力してください。`;
      }
    }
    // min
    if (item.min) {
      if (item.min > valuelength) {
        item.error  += `${item.min}文字以上で入力してください。`;
      }
    }
  }
  // max and min value
  if (item.type) {
    if (item.type === INPUT_TYPE.NUMBER) {
      // max
      if (item.max) {
        if (item.max < value) {
          item.error  += `${item.max}以下で入力してください。`;
        }
      }
      // min
      if (item.min || item.min === 0) {
        if (item.min > value) {
          item.error  += `${item.min}以上で入力してください。`;
        }
      }
    }
  }
  // emoji
  item.error += validation.hasEmoji(value, 'emoji');
  if (item.checks && valuelength > 0) {
    for (const check of item.checks) {
      item.error += validation.checkOption(value, check);
    }
  }
  return item.error.length > 0;
}

export function checkValues(values: any, items: IPValidation[]): number {

  let resulutValidation = 0;
  for (const key of Object.keys(values)) {
    const item = items.filter((v: any) => (v.key === key));
    if (item.length === 1) {
      resulutValidation = checkValue(values[key], item[0]) ? resulutValidation + 1 : resulutValidation;
    }
  }
  return resulutValidation;
}

// 空白チェック
export function isEmpty(value: string, item: IPValidation): boolean {
  const spaceRemovedString = value.replace(/\s+/g, '');
  let isBlank = false;
  if (!spaceRemovedString && value.length > 0) {
    item.error += '空白のみの入力はできません。';
    isBlank = true;
  }
  return isBlank;
}
